<template>
  <DropdownField
    inputId="cashless-pay-type"
    name="type"
    :label="translate(`${LOCALE_PREFIX}.form.planType`)"
    :placeholder="translate(`${LOCALE_PREFIX}.form.planTypePlaceholder`)"
    :options="cashlessPayTypes"
    optionLabel="label"
    optionValue="value"
    :required="editCashlessPay"
    :disabled="!editCashlessPay"
  />
</template>

<script setup lang="ts">
import { useTranslation } from '@centric-os/helpers';
import { useCashlessPay } from '../../composables';
import { storeToRefs } from 'pinia';
import { SitesLocalePrefix } from '../../../../../../enums';
import { useFinancialConfigStore } from '../../../../../../routes';

// Set localization
const { translate } = useTranslation();
const LOCALE_PREFIX = SitesLocalePrefix.SITE_MEAL_PLAN;

// Set cashless pay composable
const { cashlessPayTypes } = useCashlessPay();

// Set financial config store
const fConfigStore = useFinancialConfigStore();
const { editCashlessPay } = storeToRefs(fConfigStore);
</script>
